import { Box, FormControlLabel, Grid, Switch } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { AppState } from "../../core/app/AppReducer"
import BaseTextField from "../../core/components/base/BaseTextField"
import {
    setBeanShuffle, setGerudoCardShuffle, setIsBossShuffle, setIsCowsanity, setIsDungeonShuffle, setIsKeyring,
    // setIsKeyringGiveBk, 
    setIsKeysanity, setIsMixedPoolDungeon, setIsMixedPoolGrotto, setIsMixedPoolInterior, setIsMixedPoolOverworld, setIsMultiworld, setIsOwlRandom, setIsScrubsanity, setIsSpawnAdultRandom, setIsSpawnChildRandom, setIsWarpSongRandom, setIsWoth, setKokiriSwordShuffle, setNbBarren, setNbGoals, setNbMultiworldPlayer, setNbSometimes, setOcarinaShuffle, setUseItemTracker, setUseItemTrackerReduce, setUseLocationTracker, setUseScrubAlwaysHints, setUseShopsanity, setUseSphereTracker, setUseTrials
} from "../OotrReducer"


const OotTrackerSettingsScreen = () => {

    let dispatch = useDispatch();
    let nbGoals = useSelector((state: AppState) => state.ui.ootr.main.nbGoals)
    let nbSometimesHints = useSelector((state: AppState) => state.ui.ootr.main.nbSometimes)
    let nbBarrens = useSelector((state: AppState) => state.ui.ootr.main.nbBarren)
    let isWoth = useSelector((state: AppState) => state.ui.ootr.main.isWoth)
    let isDungeonShuffle = useSelector((state: AppState) => state.ui.ootr.main.isDungeonShuffle)
    let isBossShuffle = useSelector((state: AppState) => state.ui.ootr.main.isBossShuffle)
    let isSpawnChildRandom = useSelector((state: AppState) => state.ui.ootr.main.isSpawnChildRandom)
    let isSpawnAdultRandom = useSelector((state: AppState) => state.ui.ootr.main.isSpawnAdultRandom)
    let isWarpSongRandom = useSelector((state: AppState) => state.ui.ootr.main.isWarpSongRandom)
    let isOwlRandom = useSelector((state: AppState) => state.ui.ootr.main.isOwlRandom)
    let isMixedPoolGrotto = useSelector((state: AppState) => state.ui.ootr.main.isMixedPoolGrotto)
    let isMixedPoolInterior = useSelector((state: AppState) => state.ui.ootr.main.isMixedPoolInterior)
    let isMixedPoolDungeon = useSelector((state: AppState) => state.ui.ootr.main.isMixedPoolDungeon)
    let isMixedPoolOverworld = useSelector((state: AppState) => state.ui.ootr.main.isMixedPoolOverworld)
    let useScrubAlwaysHints = useSelector((state: AppState) => state.ui.ootr.main.useScrubSettings)
    let isScrubsanity = useSelector((state: AppState) => state.ui.ootr.main.isScrubsanity)
    let isCowsanity = useSelector((state: AppState) => state.ui.ootr.main.isCowsanity)
    let useTrials = useSelector((state: AppState) => state.ui.ootr.main.useTrials)
    let shopsanity = useSelector((state: AppState) => state.ui.ootr.main.useShopsanity)
    let useItemTracker = useSelector((state: AppState) => state.ui.ootr.main.useItemTracker)
    let useItemTrackerReduce = useSelector((state: AppState) => state.ui.ootr.main.useItemTrackerReduce)
    let useLocationTracker = useSelector((state: AppState) => state.ui.ootr.main.useLocationTracker)
    let useSphereTracker = useSelector((state: AppState) => state.ui.ootr.main.useSphereTracker)
    let ocarinaShuffle = useSelector((state: AppState) => state.ui.ootr.main.ocarinaShuffle)
    let beansShuffle = useSelector((state: AppState) => state.ui.ootr.main.beanShuffle)
    let kokiriSword = useSelector((state: AppState) => state.ui.ootr.main.kokiriSwordShuffle)
    let gerudoCardShuffle = useSelector((state: AppState) => state.ui.ootr.main.gerudoCardShuffle)
    let isMultiworld = useSelector((state: AppState) => state.ui.ootr.main.isMultiworld)
    let nbMultiworldPlayer = useSelector((state: AppState) => state.ui.ootr.main.nbMultiworldPlayer)
    let keysanity = useSelector((state: AppState) => state.ui.ootr.main.isKeysanity)
    let keyring = useSelector((state: AppState) => state.ui.ootr.main.isKeyring)
    // let keyringBk = useSelector((state: AppState) => state.ui.ootr.main.isKeyringGiveBk)


    return <Box display="flex" justifyContent="space-around" flexDirection={"row"} flexBasis={"fit-content"} flexGrow={1}>
        <Box display={"flex"} flexDirection={"column"} flexBasis={"fit-content"} >
            <h2>Global</h2>
            <FormControlLabel control={<Switch checked={isWoth} onChange={(e, v) => dispatch(setIsWoth(v))} />} label="Use Woth Hint" />
            <FormControlLabel control={<Switch checked={useScrubAlwaysHints} onChange={(e, v) => dispatch(setUseScrubAlwaysHints(v))} />} label="Use Scrub Tournament Hints" />
            <FormControlLabel control={<Switch checked={useItemTracker} onChange={(e, v) => { dispatch(setUseItemTracker(v)); dispatch(setUseItemTrackerReduce(!v)); }} />} label="Use Item Tracker" />
            <FormControlLabel control={<Switch checked={useItemTrackerReduce} onChange={(e, v) => { dispatch(setUseItemTrackerReduce(v)); dispatch(setUseItemTracker(!v)); }} />} label="Use Item Tracker based on Settings" />
            <FormControlLabel control={<Switch checked={useLocationTracker} onChange={(e, v) => { dispatch(setUseLocationTracker(v)); }} />} label="Use Location Tracker" />
            <FormControlLabel control={<Switch checked={useSphereTracker} onChange={(e, v) => { dispatch(setUseSphereTracker(v));  }} />} label="Use Sphere Tracker " />

            <BaseTextField
                value={nbGoals}
                className="ultra-dense"
                onChange={(e) => dispatch(setNbGoals(Math.min(Number(e.currentTarget.value), 10)))}
                label="Number of Path / Woth Hints"
                margin={"normal"}
                sx={{ maxWidth: "200px" }}
            />
            <BaseTextField
                value={nbSometimesHints}
                className="ultra-dense"
                onChange={(e) => dispatch(setNbSometimes(Math.min(Number(e.currentTarget.value), 10)))}
                label="Number of Sometimes Hints"
                margin={"normal"}
                sx={{ maxWidth: "200px" }}

            />
            <BaseTextField
                value={nbBarrens}
                className="ultra-dense"
                onChange={(e) => dispatch(setNbBarren(Math.min(Number(e.currentTarget.value), 5)))}
                label="Number of Barrens"
                margin={"normal"}
                sx={{ maxWidth: "200px" }}
            />
        </Box>
        <Box display={"flex"} flexDirection={"column"}>
            <h2>Dungeons / Bosses</h2>
            <FormControlLabel control={<Switch checked={isDungeonShuffle} onChange={(e, v) => dispatch(setIsDungeonShuffle(v))} />} label="Dungeon Shuffle" />
            <FormControlLabel control={<Switch checked={isBossShuffle} onChange={(e, v) => dispatch(setIsBossShuffle(v))} />} label="Boss Shuffle" />
            <FormControlLabel control={<Switch checked={useTrials} onChange={(e, v) => dispatch(setUseTrials(v))} />} label="Trials" />
        </Box>
        <Box display={"flex"} flexDirection={"column"}>
            <h2>Spawn / Warps</h2>
            <FormControlLabel control={<Switch checked={isSpawnChildRandom} onChange={(e, v) => dispatch(setIsSpawnChildRandom(v))} />} label="Child Spawn Random" />
            <FormControlLabel control={<Switch checked={isSpawnAdultRandom} onChange={(e, v) => dispatch(setIsSpawnAdultRandom(v))} />} label="Adult Spawn Random" />
            <FormControlLabel control={<Switch checked={isWarpSongRandom} onChange={(e, v) => dispatch(setIsWarpSongRandom(v))} />} label="Warp Song Destinations Random" />
            <FormControlLabel control={<Switch checked={isOwlRandom} onChange={(e, v) => dispatch(setIsOwlRandom(v))} />} label="Olws Warp Random" />

        </Box>
        <Box display={"flex"} flexDirection={"column"} flexBasis={"fit-content"} >
            <h2>Mix Pool Entrances</h2>
            <FormControlLabel control={<Switch checked={isMixedPoolGrotto} onChange={(e, v) => dispatch(setIsMixedPoolGrotto(v))} />} label="Mixpool Grotto" />
            <FormControlLabel control={<Switch checked={isMixedPoolInterior} onChange={(e, v) => dispatch(setIsMixedPoolInterior(v))} />} label="Mixpool Interior" />
            <FormControlLabel control={<Switch checked={isMixedPoolDungeon} onChange={(e, v) => dispatch(setIsMixedPoolDungeon(v))} />} label="Mixpool Dungeon" />
            <FormControlLabel control={<Switch checked={isMixedPoolOverworld} onChange={(e, v) => dispatch(setIsMixedPoolOverworld(v))} />} label="Mixpool Overworld" />

        </Box>
        <Box display={"flex"} flexDirection={"column"} flexBasis={"fit-content"} >
            <h2>Sanity</h2>
            <FormControlLabel control={<Switch checked={isScrubsanity} onChange={(e, v) => dispatch(setIsScrubsanity(v))} />} label="ScrubSanity" />
            <FormControlLabel control={<Switch checked={isCowsanity} onChange={(e, v) => dispatch(setIsCowsanity(v))} />} label="Cowsanity" />
            <FormControlLabel control={<Switch checked={shopsanity} onChange={(e, v) => dispatch(setUseShopsanity(v))} />} label="Shopsanity" />
            <FormControlLabel control={<Switch checked={keysanity} onChange={(e, v) => dispatch(setIsKeysanity(v))} />} label="Keysanity" />
            <FormControlLabel control={<Switch checked={keyring} onChange={(e, v) => dispatch(setIsKeyring(v))} />} label="Keyring Mode" />
            {/* <FormControlLabel control={<Switch checked={keyringBk} onChange={(e, v) => dispatch(setIsKeyringGiveBk(v))} />} label="Keyring give BK" /> */}
        </Box>
        <Box display={"flex"} flexDirection={"column"} flexBasis={"fit-content"} >
            <h2>Shuffle</h2>
            <FormControlLabel control={<Switch checked={ocarinaShuffle} onChange={(e, v) => dispatch(setOcarinaShuffle(v))} />} label="Ocarina" />
            <FormControlLabel control={<Switch checked={beansShuffle} onChange={(e, v) => dispatch(setBeanShuffle(v))} />} label="Beans" />
            <FormControlLabel control={<Switch checked={kokiriSword} onChange={(e, v) => dispatch(setKokiriSwordShuffle(v))} />} label="Kokiri Sword" />
            <FormControlLabel control={<Switch checked={gerudoCardShuffle} onChange={(e, v) => dispatch(setGerudoCardShuffle(v))} />} label="Gerudo Card" />
        </Box>
        <Box display={"flex"} flexDirection={"column"} flexBasis={"fit-content"} >
            <h2>Multiworld</h2>
            <FormControlLabel control={<Switch checked={isMultiworld} onChange={(e, v) => dispatch(setIsMultiworld(v))} />} label="Multiworld" />
            <BaseTextField
                value={nbMultiworldPlayer}
                className="ultra-dense"
                onChange={(e) => dispatch(setNbMultiworldPlayer(Math.max(Number(e.currentTarget.value), 2)))}
                label="Number of Players"
                margin={"normal"}
                sx={{ maxWidth: "200px" }}
            />


        </Box>
        <Grid item xs={12} sm={1}>

        </Grid>
        <Grid item xs={12} sm={1}>

        </Grid>
        <Grid item xs={12} sm={1}>

        </Grid>
    </Box >
}

export default OotTrackerSettingsScreen